import { AgricultureToastProps } from 'app/agriculture/AgricultureToast/agriculture_toast_service';
import classNames from 'classnames';
import { ToastIcon } from './ToastIcon';
import './ToastContent.scss';
import { Button, IconButton } from 'app/agriculture/components/Button/Button';

interface ToastContentProps extends AgricultureToastProps {
    onClose(): void;
}

export function ToastContent({
    type,
    title,
    subtext,
    actions,
    variant = 'simple',
    onClose,
}: ToastContentProps) {
    return (
        <div
            className={classNames(
                'ToastContent',
                `ToastContent--${variant}`,
                `ToastContent--${type}`,
            )}
            data-testid="ToastContext"
            data-cy="toast-content"
        >
            <div className="ToastContent__header">
                <ToastIcon className="ToastContent__icon" type={type} data-cy="toast-icon" />
                <div className="ToastContent__text">
                    <h5 className="ToastContent__title" data-cy="toast-title">
                        {title}
                    </h5>
                    {variant === 'simple' && subtext != null ? (
                        <p className="ToastContent__title" data-cy="toast-subtitle">
                            {subtext}
                        </p>
                    ) : null}
                </div>
                <IconButton
                    id="toast-close-button"
                    className="ToastContent__close-button"
                    tooltip="Close"
                    onClick={onClose}
                    icon="close"
                    variant="textonly"
                    data-cy="toast-close-button"
                />
            </div>
            {variant === 'detailed' && subtext != null ? (
                <div className="ToastContent__description">
                    <p className="ToastContent__subtitle" data-cy="toast-subtitle">
                        {subtext}
                    </p>
                    {!actions || actions.length === 0 ? null : (
                        <div className="ToastContent__actions" data-cy="toast-action-buttons">
                            {actions.map((action) => (
                                <Button key={action.text} {...action} />
                            ))}
                        </div>
                    )}
                </div>
            ) : null}
        </div>
    );
}
